// extracted by mini-css-extract-plugin
export default {"carouselContainer":"ImagesCarousel_carouselContainer__VDwXB","centeredCarousel":"ImagesCarousel_centeredCarousel__g7o+n"};